import { Form } from 'antd'
import styled from 'styled-components'

const FormItemStyled = styled(Form.Item)`
  .ant-form-item-explain,
  .ant-form-item-explain-error {
    display: none;
  }
`

export { FormItemStyled }
